// Smooth-scroll to a section id. Uses the active Lenis instance so that
// reveal animations (IntersectionObserver) fire reliably during the scroll.
export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -80, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

// Scroll to the Kontakt section and activate a specific tab (salg/service/deler).
export const openKontaktTab = (tab) => {
  window.dispatchEvent(new CustomEvent("kontakt:set-tab", { detail: tab }));
  scrollToId("#kontakt");
};
